// extracted by mini-css-extract-plugin
module.exports = {"main":"identifier-input__main___2NmY2","label":"identifier-input__label___3wmVZ","input":"identifier-input__input___1ZsY_"};